import type { Compute } from "@suse-o11y/compute";
import type { Object } from "@suse-o11y/object";
import type { Optional } from "@suse-o11y/optional";
import { cva } from "class-variance-authority";

// biome-ignore lint/performance/noBarrelFile: re-export
export { type VariantProps as X, cx } from "class-variance-authority";

export type VariantProp<
	TComponent extends (props: Object) => unknown,
	TProp extends keyof NonNullable<Parameters<TComponent>[0]>,
> = NonNullable<Parameters<TComponent>[0][TProp]>;

export type VariantProps<TComponent extends (props: Object) => unknown> = Partial<
	Omit<NonNullable<Parameters<TComponent>[0]>, "className">
>;

// enforce all variants to be defined
export type Props<T> = Compute<
	NonNullable<Omit<Optional<NonNullable<Parameters<ReturnType<typeof cva<T>>>[0]>>, "class">>
>;

export const cv = cva as <T>(...args: Parameters<typeof cva<T>>) => (props: Props<T>) => string;
